import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatabaseService } from '../services/database.service';

export interface EventHistoryEntry {
  timestamp: string | null;
  user: string;
  field: string;
  fieldLabel?: string;
  oldValue: any;
  newValue: any;
}

@Component({
  selector: 'app-event-history-table',
  templateUrl: './event-history-table.component.html',
  styleUrls: ['./event-history-table.component.scss'],
  standalone: false
})
export class EventHistoryTableComponent implements OnChanges {
  @Input() eventId!: string;
  @Input() fieldLabels: { [k: string]: string } = {};
  @Input() autoLoad = true;

  loading = false;
  error: string | null = null;
  entries: EventHistoryEntry[] = [];
  filterText = '';

  constructor(private db: DatabaseService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.autoLoad && changes['eventId'] && this.eventId) {
      this.load();
    }
  }

  load() {
    if (!this.eventId) return;
    this.loading = true;
    this.error = null;
    this.db.getEventHistory(this.eventId).subscribe({
      next: res => {
        const history = Array.isArray(res) ? res : [];
        this.entries = history.map((h: any) => ({
          timestamp: h.timestamp || h.created_at || h.createdAt || null,
          user: h.body.user || h.modified_by || h.name || h.email || h.gmid || 'unknown',
          field: h.field,
          fieldLabel: h.fieldLabel || this.fieldLabels[h.field] || h.field,
          oldValue: h.oldValue,
          newValue: h.newValue
        })).sort((a: any,b: any)=> new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
      },
      error: err => {
        if (err?.status === 404) {
          // Treat 404 as "no history yet" instead of an error.
          this.entries = [];
          this.error = null;
        } else {
          this.error = err?.message || 'Failed to load history';
        }
      },
      complete: () => this.loading = false
    });
  }

  get filteredEntries() {
    if (!this.filterText) return this.entries;
    const t = this.filterText.toLowerCase();
    return this.entries.filter(e =>
      e.field.toLowerCase().includes(t) ||
      (e.fieldLabel||'').toLowerCase().includes(t) ||
      (''+e.oldValue).toLowerCase().includes(t) ||
      (''+e.newValue).toLowerCase().includes(t) ||
      e.user.toLowerCase().includes(t)
    );
  }
}
